import validate from "/home/mousa/Documents/Projecty/lst-navigator/node_modules/nuxt/dist/pages/runtime/validate.js";
import install_45global from "/home/mousa/Documents/Projecty/lst-navigator/middleware/install.global.ts";
import manifest_45route_45rule from "/home/mousa/Documents/Projecty/lst-navigator/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  install_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/mousa/Documents/Projecty/lst-navigator/middleware/auth.ts")
}